import axios from "axios";


axios.interceptors.request.use(
    function (config) {
        if (config.data instanceof FormData) {
            // make sure we don't force JSON
            delete config.headers['Content-Type'];
        } else {
            // only set JSON if not already defined
            if (!config.headers['Content-Type']) {
                config.headers['Content-Type'] = 'application/json';
            }
        }

        // withCredentials is NOT a header, it's a config flag
        config.withCredentials = true;
        if (JSON.parse(localStorage.getItem('user-info'))) {
            config.headers["company"] = JSON.parse(localStorage.getItem('user-info')).company;
            config.headers["Authorization"] = "Bearer " + JSON.parse(localStorage.getItem('user-info')).token;
        }
        return config;
    },
    function (error) {
        return Promise.reject(error);
    }
);


axios.interceptors.response.use(function (response) {
    return response;
}, function (error) {
    if (error.response.status === 401) {
        //console.log("401");
        localStorage.clear();
        window.dispatchEvent(new Event("storage"));
    }

    if (error.response.status === 500) {

        if (error.response.data.hasOwnProperty("message") && error.response.data.message == "Unauthenticated.") {
            if (!window.location.pathname.includes("confirmation_reponse")) window.location.reload();
            localStorage.clear();
            window.dispatchEvent(new Event("storage"));
        }
    }
    return Promise.reject(error);
});